import { type BeaconClient } from "@beacon/client-core";
import { postSignedToService } from "../../platform/post-signed.js";

const utf8 = (s: string) => new TextEncoder().encode(s);

export interface FlagPublishInput {
  subject: string;
  reason: string;
  note: string; // plaintext; sealed if non-empty
  cell: string; // res-8 cell for the envelope geo (the flagger's home/browse cell)
}

/**
 * Publish a PRIVATE app.aid.mod.flag (moderation spec §4 — server-only-private,
 * anti-retaliation). The flag is signed (real crypto) but NEVER hits the public
 * firehose: the signed wire bytes are POSTed straight to the moderation service,
 * exactly like helper availability (A7) and the supporter pledge. An optional
 * note is sealed under an epoch snapshot so only ciphertext leaves the device.
 */
export async function publishFlag(
  client: BeaconClient,
  input: FlagPublishInput,
  postUrl: string,
  fetchImpl: typeof fetch = fetch,
): Promise<void> {
  const payload: Record<string, unknown> = { subject: input.subject, reason: input.reason };
  const note = input.note.trim();
  if (note) {
    const snap = await client.epochSnapshot();
    payload.note = await client.sealBroadcastWith(snap, utf8(note));
  }
  await postSignedToService(client, { $type: "app.aid.mod.flag", payload, cell: input.cell }, postUrl, fetchImpl, "flag");
}
